export function smoothScrollbarTest() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/android|iphone|ipad|ipod|opera mini|iemobile|mobile/i.test(userAgent))
    return false;

  if (document.body.classList.contains('macos')) return false;
  if (document.body.classList.contains('mobile')) return false;

  return true;
}
